import React, { useState, useEffect } from 'react';
import FormHelperText from '@mui/material/FormHelperText';
import TextField from '@mui/material/TextField';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import Checkbox from '@mui/material/Checkbox';
import IconButton from '@mui/material/IconButton';
import { getIn } from 'formik';
import NumberFormatCustom from '../../common/form/NumberFormatCustom';
import NumberFormatText from '../../common/form/NumberFormatText';
import { getNumberComma } from '../../../utils/numberUtils';
import koLocale from 'date-fns/locale/ko';
import DateAdapter from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import DatePicker from '@mui/lab/DatePicker';
import DeleteIcon from '@mui/icons-material/Delete';

const PurchaseForm = ({ index, bill, formik, onDelete }) => {
  const [invTot, setInvTot] = useState(0);

  useEffect(() => {
    const tot = Number(bill?.invAmt) + Number(bill?.invVat);
    setInvTot(tot);
    // console.log(bill?.invTot, ':', tot);
  }, [bill?.invAmt, bill?.invVat]);

  const reqCompDt = `purchaseBills[${index}].reqCompDt`;
  const touchedReqCompDt = getIn(formik.touched, reqCompDt);
  const errorReqCompDt = getIn(formik.errors, reqCompDt);

  const prodCompDt = `purchaseBills[${index}].prodCompDt`;
  const touchedProdCompDt = getIn(formik.touched, prodCompDt);
  const errorProdCompDt = getIn(formik.errors, prodCompDt);

  const invAmt = `purchaseBills[${index}].invAmt`;
  const touchedInvAmt = getIn(formik.touched, invAmt);
  const errorInvAmt = getIn(formik.errors, invAmt);

  const invVat = `purchaseBills[${index}].invVat`;
  const touchedInvVat = getIn(formik.touched, invVat);
  const errorInvVat = getIn(formik.errors, invVat);

  const invTxt = `purchaseBills[${index}].invTxt`;
  const touchedInvTxt = getIn(formik.touched, invTxt);
  const errorInvTxt = getIn(formik.errors, invTxt);

  const osTran = `purchaseBills[${index}].osTran`;

  const buyDiv = `purchaseBills[${index}].buyDiv`;
  const touchedBuyDiv = getIn(formik.touched, buyDiv);
  const errorBuyDiv = getIn(formik.errors, buyDiv);

  const [message, setMessage] = useState('');

  const changeDiv = (divder) => {
    if (divder !== '' && divder !== null) {
      const alotal = parseInt(bill?.billSumTotal);
      const itotal = parseInt(bill?.billIssuedTotal);
      const total = alotal - itotal;

      const div = parseInt(divder);

      const val = Math.round(total / div);
      formik.setFieldValue(invAmt, val);
    }
  };

  const changeVal = (value) => {
    const total = parseInt(bill?.billSumTotal);
    const billIssuedTotal = parseInt(bill?.billIssuedTotal);
    const val = parseInt(value);

    const vat = val / 10;
    if (!checked && vat > 0) {
      formik.setFieldValue(invVat, vat);
    }

    //기매입가 + 매입가 > 총매입가
    if (total < billIssuedTotal + val) {
      const over = billIssuedTotal + val - total;
      setMessage(`${getNumberComma(over)} 초과`);
    } else {
      setMessage('');
    }
  };

  // 부가세 계산하기
  const getInvVat = () => {
    const val = parseInt(formik.values.purchaseBills[index].invAmt);

    const vat = val / 10;
    if (vat > 0) {
      formik.setFieldValue(invVat, vat);
    }
  };

  const [checked, setChecked] = useState(false);
  const [disabled, setDisalbed] = useState(false);

  const handleChange = (event) => {
    setChecked(event.target.checked);
    formik.setFieldValue(osTran, event.target.checked ? 'Y' : 'N');

    if (event.target.checked) {
      //해외 거래가 체크되어 있으면
      setDisalbed(true);
      formik.setFieldValue(invVat, 0);
    } else {
      setDisalbed(false);
      getInvVat();
    }
  };

  useEffect(() => {
    if (formik?.values?.purchaseBills[index]?.osTran === 'Y') {
      setChecked(true);
    } else {
      setChecked(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formik?.values?.purchaseBills[index]?.osTran]);

  return (
    <>
      <TableRow>
        <TableCell align="center">{index + 1}</TableCell>
        <TableCell sx={{ width: 140, px: 1 }}>
          <LocalizationProvider dateAdapter={DateAdapter} locale={koLocale}>
            <DatePicker
              inputFormat={'yyyy-MM-dd'}
              mask={'____-__-__'}
              id="reqCompDt"
              name="reqCompDt"
              value={formik.values.purchaseBills[index].reqCompDt}
              onChange={(newValue) => {
                formik.setFieldValue(reqCompDt, newValue);
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="standard"
                  fullWidth
                  error={Boolean(touchedReqCompDt && errorReqCompDt)}
                  helperText={
                    touchedReqCompDt && errorReqCompDt ? errorReqCompDt : ''
                  }
                />
              )}
            />
          </LocalizationProvider>
        </TableCell>
        <TableCell sx={{ width: 150 }}>{bill.partnerNm}</TableCell>
        <TableCell>
          <TextField
            variant="standard"
            required
            size="small"
            fullWidth
            id="invTxt"
            name={invTxt}
            helperText={touchedInvTxt && errorInvTxt ? errorInvTxt : ''}
            error={Boolean(touchedInvTxt && errorInvTxt)}
            value={formik.values.purchaseBills[index].invTxt}
            onChange={(e) => {
              formik.setFieldValue(invTxt, e.target.value);
            }}
            onBlur={formik.handleBlur}
          />
        </TableCell>
        <TableCell align="center">
          <Checkbox
            name={osTran}
            checked={checked}
            onChange={handleChange}
            inputProps={{ 'aria-label': osTran }}
          />
        </TableCell>
        <TableCell align="right" sx={{ px: 1 }}>
          {getNumberComma(bill.billSumTotal)}
        </TableCell>
        <TableCell align="right" sx={{ px: 1 }}>
          {getNumberComma(bill.billIssuedTotal)}
        </TableCell>
        <TableCell align="right" sx={{ px: 1 }}>
          {getNumberComma(invTot)}
        </TableCell>
        <TableCell sx={{ width: 150, px: 1 }}>
          <TextField
            size="small"
            required
            variant="standard"
            fullWidth
            name={invAmt}
            value={formik.values.purchaseBills[index].invAmt}
            helperText={touchedInvAmt && errorInvAmt ? errorInvAmt : ''}
            error={Boolean(touchedInvAmt && errorInvAmt)}
            onChange={(e) => {
              formik.setFieldValue(invAmt, e.target.value);
              changeVal(e.target.value);
            }}
            onBlur={formik.handleBlur}
            InputProps={{
              inputComponent: NumberFormatCustom,
            }}
          />
          {message !== '' && (
            <FormHelperText sx={{ color: 'error.main' }}>
              {message}
            </FormHelperText>
          )}
        </TableCell>
        <TableCell sx={{ width: 100, px: 1 }}>
          <TextField
            size="small"
            required
            variant="standard"
            fullWidth
            name={invVat}
            disabled={disabled}
            value={formik.values.purchaseBills[index]?.invVat}
            helperText={touchedInvVat && errorInvVat ? errorInvVat : ''}
            error={Boolean(touchedInvVat && errorInvVat)}
            onChange={(e) => {
              formik.setFieldValue(invVat, e.target.value);
            }}
            onBlur={formik.handleBlur}
            InputProps={{
              inputComponent: NumberFormatCustom,
            }}
          />
        </TableCell>
        <TableCell sx={{ width: 140, px: 1 }}>
          <LocalizationProvider dateAdapter={DateAdapter} locale={koLocale}>
            <DatePicker
              inputFormat={'yyyy-MM-dd'}
              mask={'____-__-__'}
              id="prodCompDt"
              name="prodCompDt"
              value={formik.values.purchaseBills[index].prodCompDt}
              onChange={(newValue) => {
                formik.setFieldValue(prodCompDt, newValue);
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="standard"
                  fullWidth
                  error={Boolean(touchedProdCompDt && errorProdCompDt)}
                  helperText={
                    touchedProdCompDt && errorProdCompDt ? errorProdCompDt : ''
                  }
                />
              )}
            />
          </LocalizationProvider>
        </TableCell>
        <TableCell sx={{ width: 80 }}>
          <TextField
            size="small"
            required
            variant="standard"
            fullWidth
            name={buyDiv}
            value={formik.values.purchaseBills[index].buyDiv || 1}
            helperText={touchedBuyDiv && errorBuyDiv ? errorBuyDiv : ''}
            error={Boolean(touchedBuyDiv && errorBuyDiv)}
            onChange={(e) => {
              formik.setFieldValue(buyDiv, e.target.value);
              changeDiv(e.target.value);
            }}
            onBlur={formik.handleBlur}
            InputProps={{
              inputComponent: NumberFormatText,
            }}
          />
        </TableCell>
        <TableCell align="center" sx={{ width: 80 }}>
          <IconButton
            aria-label="delete"
            size="small"
            onClick={() => onDelete(index)}
          >
            <DeleteIcon fontSize="small" />
          </IconButton>
        </TableCell>
      </TableRow>
    </>
  );
};

export default PurchaseForm;
